<template>
  <div>
    <ts-loading-banner :loading="loading">
      <fieldset>
        <legend class="text-black">
          {{ $t('question.academicProgram') }}
        </legend>
        <div class="mb-3">
          <label class="form-label required">
            {{ $t('question.mainProgram') }}
          </label>
          <select
            class="form-control"
            v-model="model.acp_id"
            @change="onChangeMainProgram(model.acp_id)"
            :class="{ 'is-invalid': errors.has('acp_id') }"
            :disabled="disableSelect"
          >
            <option :value="null" disabled selected style="display: none;">
              {{ $t('select') }}
            </option>
            <option
              v-for="(main, index) in main_programs"
              :key="index"
              :value="main.acp_id"
            >
              {{ main.acp_name_foreign }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('acp_id')">
            {{ errors.first('acp_id') }}
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label required">
            {{ $t('question.subProgram') }}
          </label>
          <ts-loading-banner :loading="fetch_sub">
            <select
              class="form-control"
              v-model="model.acps_id"
              @change="onChangeSubProgram(model.acps_id)"
              :class="{ 'is-invalid': errors.has('acps_id') }"
              :disabled="disableSelect"
            >
              <option :value="null" disabled selected style="display: none;">
                {{ $t('select') }}
              </option>
              <option
                v-for="(sub, index) in sub_programs"
                :key="index"
                :value="sub.acps_id"
              >
                {{ sub.acps_name_foreign }}
              </option>
            </select>
            <div class="invalid-feedback" v-if="errors.has('acps_id')">
              {{ errors.first('acps_id') }}
            </div>
          </ts-loading-banner>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="mb-3">
              <label class="form-label required">
                {{ $t('question.level') }}
              </label>
              <ts-loading-banner :loading="fetch_level">
                <select
                  class="form-control"
                  v-model="model.level_id"
                  @change="onChangeLevel(model.level_id)"
                  :class="{ 'is-invalid': errors.has('level_id') }"
                  :disabled="disableSelect"
                >
                  <option
                    :value="null"
                    disabled
                    selected
                    style="display: none;"
                  >
                    {{ $t('select') }}
                  </option>
                  <option
                    v-for="(level, index) in levels"
                    :key="index"
                    :value="level.level_id"
                  >
                    {{ level.level_name_foreign }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('level_id')">
                  {{ errors.first('level_id') }}
                </div>
              </ts-loading-banner>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3">
              <label class="form-label required">
                {{ $t('question.grade') }}
              </label>
              <ts-loading-banner :loading="fetch_grade">
                <select
                  class="form-control"
                  v-model="model.grade_id"
                  :class="{ 'is-invalid': errors.has('grade_id') }"
                >
                  <option
                    :value="null"
                    disabled
                    selected
                    style="display: none;"
                  >
                    {{ $t('select') }}
                  </option>
                  <option
                    v-for="(grade, index) in grades"
                    :key="index"
                    :value="grade.grade_id"
                  >
                    {{ grade.grade_name_foreign }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('grade_id')">
                  {{ errors.first('grade_id') }}
                </div>
              </ts-loading-banner>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="mb-3">
              <label class="form-label required">
                {{ $t('question.scoringType') }}
              </label>
              <select
                class="form-control"
                :class="{ 'is-invalid': errors.has('sc_bas_id') }"
                v-model.number="model.sc_bas_id"
              >
                <option :value="null" disabled selected style="display: none;">
                  {{ $t('select') }}
                </option>
                <option
                  v-for="(score, index) in scoreBases"
                  :key="index"
                  :value="score.sc_bas_id"
                >
                  {{ score.sc_ass_bases }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('sc_bas_id')">
                {{ errors.first('sc_bas_id') }}
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3">
              <label class="form-label">
                {{ $t('question.scoringType') }}
              </label>
              <select
                class="form-control"
                :class="{ 'is-invalid': errors.has('sc_bas_id') }"
                v-model.number="model.sc_bas_id"
              >
                <option :value="null" disabled selected style="display: none;">
                  {{ $t('select') }}
                </option>
                <option
                  v-for="(score, index) in scoreBases"
                  :key="index"
                  :value="score.sc_bas_id"
                >
                  {{ score.sc_ass_bases }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="mb-3">
              <label class="form-label">
                {{ $t('question.scoringType') }}
              </label>
              <select
                class="form-control"
                :class="{ 'is-invalid': errors.has('sc_bas_id') }"
                v-model.number="model.sc_bas_id"
              >
                <option :value="null" disabled selected style="display: none;">
                  {{ $t('select') }}
                </option>
                <option
                  v-for="(score, index) in scoreBases"
                  :key="index"
                  :value="score.sc_bas_id"
                >
                  {{ score.sc_ass_bases }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mb-3">
              <label class="form-label">
                {{ $t('question.scoringType') }}
              </label>
              <select
                class="form-control"
                :class="{ 'is-invalid': errors.has('sc_bas_id') }"
                v-model.number="model.sc_bas_id"
              >
                <option :value="null" disabled selected style="display: none;">
                  {{ $t('select') }}
                </option>
                <option
                  v-for="(score, index) in scoreBases"
                  :key="index"
                  :value="score.sc_bas_id"
                >
                  {{ score.sc_ass_bases }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="invalid-feedback" v-if="errors.has('sc_bas_id')">
          {{ errors.first('sc_bas_id') }}
        </div>
      </fieldset>
    </ts-loading-banner>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'academicProgram',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      fetch_sub: false,
      fetch_level: false,
      fetch_grade: false,
      sub_programs: [],
      levels: [],
      grades: [],
      model: {}
    }
  },
  computed: {
    ...mapState('eschool/eExam/question', [
      'main_programs',
      'scoreBases',
      'edit_data'
    ]),
    disableSelect() {
      if (!_.isEmpty(this.edit_data)) {
        return true
      }
      return false
    }
  },
  created() {
    this.model = this.value
    this.fetchPreData()
  },
  methods: {
    ...mapActions('eschool/eExam/question', [
      'getMainProgram',
      'getSubProgram',
      'getLevel',
      'getGrade',
      'getScoreBase'
    ]),
    async fetchPreData() {
      this.loading = true
      await this.getScoreBase()
        .then(() => {})
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.getMainProgram()
        .then(() => {
          this.setEdit()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onChangeMainProgram(acp_id) {
      this.fetch_sub = true
      this.model.acps_id = null
      this.model.level_id = null
      this.model.grade_id = null
      this.getSubProgram({ acp_id: acp_id })
        .then(response => {
          this.fetch_sub = false
          this.sub_programs = _.orderBy(response.data, ['acps_name_foreign'])
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_sub = false
        })
    },
    onChangeSubProgram(acps_id) {
      this.fetch_level = true
      this.model.level_id = null
      this.model.grade_id = null
      this.getLevel({ acps_id: acps_id })
        .then(response => {
          this.fetch_level = false
          this.levels = _.orderBy(response.data, ['level_name_foreign'])
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_level = false
        })
    },
    onChangeLevel(level_id) {
      this.fetch_grade = true
      this.model.grade_id = null
      this.getGrade({ level_id: level_id })
        .then(response => {
          this.fetch_grade = false
          this.grades = _.orderBy(response.data, ['grade_name_foreign'])
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_grade = false
        })
    },
    async setEdit() {
      if (!_.isEmpty(this.edit_data) && this.edit_data !== undefined) {
        await this.onChangeLevel(this.edit_data.grade.level.level_id)
        await this.onChangeSubProgram(
          this.edit_data.grade.level.sub_program.acps_id
        )
        await this.onChangeMainProgram(
          this.edit_data.grade.level.sub_program.main_program.acp_id
        )
        this.model.acp_id = this.edit_data.grade.level.sub_program.main_program.acp_id
        this.model.acps_id = this.edit_data.grade.level.sub_program.acps_id
        this.model.level_id = this.edit_data.grade.level.level_id
        this.model.grade_id = this.edit_data.grade_id
        this.model.sc_bas_id = this.edit_data.sc_bas_id
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style scoped>
label {
  margin-bottom: 0 !important;
}
</style>
